import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AIIcon = (props: IconProps) => (
  <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      id="Vector"
      d="M12.6665 5.99935L13.4998 4.16602L15.3332 3.33268L13.4998 2.49935L12.6665 0.666016L11.8332 2.49935L9.99984 3.33268L11.8332 4.16602L12.6665 5.99935ZM7.6665 6.33268L5.99984 2.66602L4.33317 6.33268L0.666504 7.99935L4.33317 9.66601L5.99984 13.3327L7.6665 9.66601L11.3332 7.99935L7.6665 6.33268ZM12.6665 9.99935L11.8332 11.8327L9.99984 12.666L11.8332 13.4993L12.6665 15.3327L13.4998 13.4993L15.3332 12.666L13.4998 11.8327L12.6665 9.99935Z"
    />
  </Icon>
);

export default memo(AIIcon);
